import React, { useCallback, useEffect, useState } from "react";
import s from './RegClass.module.css';
import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import {modifiedDate, dateDiff} from '../middleware/dateControl';
//import {useSpring, animated, easings  }from "react-spring";
import moment from 'moment';

export default function RegClass(prop) {	
	const navigate = useNavigate();
	
	let tutorId = prop.tutorId;
	
	const [regClass, setRegClass] = useState([]);
	
	const fetchData = () => {
	
		getData('tutorApi/getRegClassById?tutorId=' + tutorId, navigate)
		.then(res => {			
				setRegClass(res.data);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const [startN, setStartN] = useState(100);
	const [endN, setEndN] = useState(100);
	/*const props = useSpring({ val: endN , from: { val: startN },
		delay:200,
	});*/

	const [toggle, setToggle] = useState(true);
	/*const TestBtn = () => {
		return <animated.div className="number">
			{props.val.interpolate(val => {
				let lNum = Math.max(endN, startN);
				let sNum = Math.min(endN, startN);
				
				if (val > lNum) {
					return lNum
				} else if (val < sNum) {
					return sNum;
				}	
				
				if (startN < endN) {
					return Math.ceil(val)
				} else {
					return Math.floor(val)
				}
			})}
		</animated.div>;
	}*/
	
	
	const RegClass = ({regClass}) => {
		
	const [cFieldName, setCFieldName] = useState("aa");
		return (<div>
		
		<div className={s.fieldName}>{cFieldName}</div>
		
		{
			regClass.map(v=> (<div className={s.reg_class_row} key={v.zoomId}>
				<div className={s.basicHolder}>
					<span className={s.basicData} onMouseEnter={()=>setCFieldName("Tutor Group id")}>{v.tutorGroupId}</span>
					<span className={s.basicData} onMouseEnter={()=>setCFieldName("Zoom id")}>{v.zoomId}</span>
					<span className={s.basicData} onMouseEnter={()=>setCFieldName("Item id")}>{v.itemId}</span>
					<span className={[s.basicData, s.descriptionCode].join(" ")} onMouseEnter={()=>setCFieldName("Description Code id")}>{v.descriptionCodeId}</span>
					<span className={[s.basicData, s.rcLessonType].join(" ")} onMouseEnter={()=>setCFieldName("RC Lesson Type")}>{v.rcLessonType}</span>
					<span className={[s.basicData, s.rcLessonSubType].join(" ")} onMouseEnter={()=>setCFieldName("RC Lesson Sub Type")}>{v.rcLessonSubType}</span>
					<span className={[s.basicData, s.startDate].join(" ")} onMouseEnter={()=>setCFieldName("Zoom Start Time")}>{modifiedDate(v.zStartDate)}</span>
					<span className={[s.basicData, s.startDate].join(" ")} onMouseEnter={()=>setCFieldName("Task Start Time")}>{modifiedDate(v.lessonStartTime)}</span>
					<span className={[s.basicData, s.startDate].join(" ")} onMouseEnter={()=>setCFieldName("Date Diff")}>{dateDiff(v.zStartDate, v.lessonStartTime)}</span>
				</div>
				<div className={s.taskList}>
					{
						v.lesson.map(l=> (<div className={s.basicData} key={v.tutorGroupId + '-' + l.lesson_id}  onMouseEnter={()=>setCFieldName("Tasks")}>
							{l.lesson_type}
						
						</div>))
					}
				</div>
				
			</div>))
			
			
		}</div>)
	}
	
	return (<div className={s.container}>
	
	{/*<TestBtn />
		<button onClick={()=>{
			if (toggle) {
				setStartN(100);
				setEndN(50);
			} else {
				setStartN(50);
				setEndN(100);
			
			}
			setToggle(!toggle);
}}>billChange</button>*/}
		<RegClass regClass = {regClass}/>
	</div>);
}